import { render, staticRenderFns } from "./NewChangeLog.vue?vue&type=template&id=76c31f9f&scoped=true"
import script from "./NewChangeLog.vue?vue&type=script&lang=js"
export * from "./NewChangeLog.vue?vue&type=script&lang=js"
import style0 from "./NewChangeLog.vue?vue&type=style&index=0&id=76c31f9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c31f9f",
  null
  
)

export default component.exports